import { defineMessages } from '@/i18n'

export const dashboardMessages = defineMessages({
  en: {
    loadingDashboard: 'Loading dashboard',
    couldNotLoad: 'Could not load the dashboard.',
    title: 'Dashboard',
    liveBoard: 'Live board · refreshes every minute',
    readModelRefreshed: ' · read model refreshed {date}',
    today: 'Today · {date}',
    latestDayHint: 'Latest day with questionnaires',
    questionnaires: 'Questionnaires',
    crewDays: 'Crew-days',
    projects: 'Projects',
    activeCrews: 'Active crews',
    executed: 'Executed',
    revenueSub: 'Revenue (SUB)',
    questionnairesByProject: 'Questionnaires by project',
    noQuestionnaires: 'No questionnaires recorded for this day yet.',
    latestRtk: 'Latest RTK measurements',
    mostRecent: { one: '{count} most recent', other: '{count} most recent' },
    lastMeasured: ' · last {date}',
    noRtk: 'No RTK measurements yet.',
    lastDays: { one: 'Last {count} day · {from} – {to}', other: 'Last {count} days · {from} – {to}' },
    colProject: 'Project',
    colQuestionnaires: 'Questionnaires',
    colCrewDays: 'Crew-days',
    colMetres: 'Metres',
    colDate: 'Date',
    colCrew: 'Crew',
    colType: 'Type',
    colLength: 'Length',
    colPoints: 'Points',
    colFix: 'Fix',
    colCity: 'City',
    viewOnMap: 'View on the RTK map',
    chartExecutedByDay: 'Executed metres by day',
    chartExecutedByDaySub: 'Total Metri per day',
    chartRtkByDay: 'RTK metres by day',
    chartRtkByDaySub: 'Metres captured per day (edited lengths applied)',
    chartProjectsByMetres: 'Projects by executed metres',
    chartRtkByType: 'RTK by measurement type',
    chartRtkByTypeSub: 'slic / trasse are cable lines; the rest are house connections',
    // KPI tiles (labels keyed by the API's kpi key; the API's label is the fallback)
    kpiMetres: 'Executed',
    kpiRevenue: 'Revenue (SUB)',
    kpiCrewdays: 'Crew-days',
    kpiCrews: 'Active crews',
    kpiProjects: 'Active projects',
    kpiHours: 'Man-hours',
    kpiSurveyed: 'Metres surveyed',
    kpiSegments: 'Segments',
    kpiPoints: 'Points',
    kpiHa: 'House connections',
    kpiFix: 'RTK-fix rate %',
  },
  de: {
    loadingDashboard: 'Übersicht wird geladen',
    couldNotLoad: 'Die Übersicht konnte nicht geladen werden.',
    title: 'Übersicht',
    liveBoard: 'Live-Ansicht · aktualisiert sich jede Minute',
    readModelRefreshed: ' · Lesemodell aktualisiert am {date}',
    today: 'Heute · {date}',
    latestDayHint: 'Letzter Tag mit Fragebögen',
    questionnaires: 'Fragebögen',
    crewDays: 'Kolonnentage',
    projects: 'Projekte',
    activeCrews: 'Aktive Kolonnen',
    executed: 'Ausgeführt',
    revenueSub: 'Umsatz (SUB)',
    questionnairesByProject: 'Fragebögen nach Projekt',
    noQuestionnaires: 'Für diesen Tag wurden noch keine Fragebögen erfasst.',
    latestRtk: 'Neueste RTK-Messungen',
    mostRecent: { one: 'die neueste {count}', other: 'die neuesten {count}' },
    lastMeasured: ' · zuletzt am {date}',
    noRtk: 'Noch keine RTK-Messungen.',
    lastDays: { one: 'Letzter {count} Tag · {from} – {to}', other: 'Letzte {count} Tage · {from} – {to}' },
    colProject: 'Projekt',
    colQuestionnaires: 'Fragebögen',
    colCrewDays: 'Kolonnentage',
    colMetres: 'Meter',
    colDate: 'Datum',
    colCrew: 'Kolonne',
    colType: 'Typ',
    colLength: 'Länge',
    colPoints: 'Punkte',
    colFix: 'Fix',
    colCity: 'Ort',
    viewOnMap: 'Auf der RTK-Karte anzeigen',
    chartExecutedByDay: 'Ausgeführte Meter pro Tag',
    chartExecutedByDaySub: 'Summe Metri pro Tag',
    chartRtkByDay: 'RTK-Meter pro Tag',
    chartRtkByDaySub: 'Erfasste Meter pro Tag (bearbeitete Längen berücksichtigt)',
    chartProjectsByMetres: 'Projekte nach ausgeführten Metern',
    chartRtkByType: 'RTK nach Messart',
    chartRtkByTypeSub: 'slic / trasse sind Kabeltrassen; der Rest sind Hausanschlüsse',
    kpiMetres: 'Ausgeführt',
    kpiRevenue: 'Umsatz (SUB)',
    kpiCrewdays: 'Kolonnentage',
    kpiCrews: 'Aktive Kolonnen',
    kpiProjects: 'Aktive Projekte',
    kpiHours: 'Arbeitsstunden',
    kpiSurveyed: 'Vermessene Meter',
    kpiSegments: 'Segmente',
    kpiPoints: 'Punkte',
    kpiHa: 'Hausanschlüsse',
    kpiFix: 'RTK-Fix-Quote %',
  },
  cnr: {
    loadingDashboard: 'Učitavanje pregleda',
    couldNotLoad: 'Nije moguće učitati pregled.',
    title: 'Pregled',
    liveBoard: 'Pregled uživo · osvježava se svake minute',
    readModelRefreshed: ' · model za čitanje osvježen {date}',
    today: 'Danas · {date}',
    latestDayHint: 'Posljednji dan s upitnicima',
    questionnaires: 'Upitnici',
    crewDays: 'Dani kolona',
    projects: 'Projekti',
    activeCrews: 'Aktivne kolone',
    executed: 'Izvedeno',
    revenueSub: 'Prihod (SUB)',
    questionnairesByProject: 'Upitnici po projektu',
    noQuestionnaires: 'Za ovaj dan još nema unesenih upitnika.',
    latestRtk: 'Najnovija RTK mjerenja',
    mostRecent: { one: '{count} najnovije', few: '{count} najnovija', other: '{count} najnovijih' },
    lastMeasured: ' · posljednje {date}',
    noRtk: 'Još nema RTK mjerenja.',
    lastDays: { one: 'Posljednji {count} dan · {from} – {to}', few: 'Posljednja {count} dana · {from} – {to}', other: 'Posljednjih {count} dana · {from} – {to}' },
    colProject: 'Projekat',
    colQuestionnaires: 'Upitnici',
    colCrewDays: 'Dani kolona',
    colMetres: 'Metri',
    colDate: 'Datum',
    colCrew: 'Kolona',
    colType: 'Tip',
    colLength: 'Dužina',
    colPoints: 'Tačke',
    colFix: 'Fix',
    colCity: 'Mjesto',
    viewOnMap: 'Prikaži na RTK karti',
    chartExecutedByDay: 'Izvedeni metri po danu',
    chartExecutedByDaySub: 'Ukupno metara po danu',
    chartRtkByDay: 'RTK metri po danu',
    chartRtkByDaySub: 'Snimljeni metri po danu (s izmijenjenim dužinama)',
    chartProjectsByMetres: 'Projekti po izvedenim metrima',
    chartRtkByType: 'RTK po vrsti mjerenja',
    chartRtkByTypeSub: 'slic / trasse su kablovske trase; ostalo su kućni priključci',
    kpiMetres: 'Izvedeno',
    kpiRevenue: 'Prihod (SUB)',
    kpiCrewdays: 'Dani kolona',
    kpiCrews: 'Aktivne kolone',
    kpiProjects: 'Aktivni projekti',
    kpiHours: 'Radni sati',
    kpiSurveyed: 'Snimljeni metri',
    kpiSegments: 'Segmenti',
    kpiPoints: 'Tačke',
    kpiHa: 'Kućni priključci',
    kpiFix: 'Stopa RTK fiksa %',
  },
  bs: {
    loadingDashboard: 'Učitavanje pregleda',
    couldNotLoad: 'Nije moguće učitati pregled.',
    title: 'Pregled',
    liveBoard: 'Pregled uživo · osvježava se svake minute',
    readModelRefreshed: ' · model za čitanje osvježen {date}',
    today: 'Danas · {date}',
    latestDayHint: 'Posljednji dan s upitnicima',
    questionnaires: 'Upitnici',
    crewDays: 'Dani kolona',
    projects: 'Projekti',
    activeCrews: 'Aktivne kolone',
    executed: 'Izvedeno',
    revenueSub: 'Prihod (SUB)',
    questionnairesByProject: 'Upitnici po projektu',
    noQuestionnaires: 'Za ovaj dan još nema unesenih upitnika.',
    latestRtk: 'Najnovija RTK mjerenja',
    mostRecent: { one: '{count} najnovije', few: '{count} najnovija', other: '{count} najnovijih' },
    lastMeasured: ' · posljednje {date}',
    noRtk: 'Još nema RTK mjerenja.',
    lastDays: { one: 'Posljednji {count} dan · {from} – {to}', few: 'Posljednja {count} dana · {from} – {to}', other: 'Posljednjih {count} dana · {from} – {to}' },
    colProject: 'Projekat',
    colQuestionnaires: 'Upitnici',
    colCrewDays: 'Dani kolona',
    colMetres: 'Metri',
    colDate: 'Datum',
    colCrew: 'Kolona',
    colType: 'Tip',
    colLength: 'Dužina',
    colPoints: 'Tačke',
    colFix: 'Fix',
    colCity: 'Mjesto',
    viewOnMap: 'Prikaži na RTK karti',
    chartExecutedByDay: 'Izvedeni metri po danu',
    chartExecutedByDaySub: 'Ukupno metara po danu',
    chartRtkByDay: 'RTK metri po danu',
    chartRtkByDaySub: 'Snimljeni metri po danu (s izmijenjenim dužinama)',
    chartProjectsByMetres: 'Projekti po izvedenim metrima',
    chartRtkByType: 'RTK po vrsti mjerenja',
    chartRtkByTypeSub: 'slic / trasse su kablovske trase; ostalo su kućni priključci',
    kpiMetres: 'Izvedeno',
    kpiRevenue: 'Prihod (SUB)',
    kpiCrewdays: 'Dani kolona',
    kpiCrews: 'Aktivne kolone',
    kpiProjects: 'Aktivni projekti',
    kpiHours: 'Radni sati',
    kpiSurveyed: 'Snimljeni metri',
    kpiSegments: 'Segmenti',
    kpiPoints: 'Tačke',
    kpiHa: 'Kućni priključci',
    kpiFix: 'Stopa RTK fiksa %',
  },
  sr: {
    loadingDashboard: 'Učitavanje pregleda',
    couldNotLoad: 'Nije moguće učitati pregled.',
    title: 'Pregled',
    liveBoard: 'Pregled uživo · osvežava se svake minute',
    readModelRefreshed: ' · model za čitanje osvežen {date}',
    today: 'Danas · {date}',
    latestDayHint: 'Poslednji dan s upitnicima',
    questionnaires: 'Upitnici',
    crewDays: 'Dani kolona',
    projects: 'Projekti',
    activeCrews: 'Aktivne kolone',
    executed: 'Izvedeno',
    revenueSub: 'Prihod (SUB)',
    questionnairesByProject: 'Upitnici po projektu',
    noQuestionnaires: 'Za ovaj dan još nema unesenih upitnika.',
    latestRtk: 'Najnovija RTK merenja',
    mostRecent: { one: '{count} najnovije', few: '{count} najnovija', other: '{count} najnovijih' },
    lastMeasured: ' · poslednje {date}',
    noRtk: 'Još nema RTK merenja.',
    lastDays: { one: 'Poslednji {count} dan · {from} – {to}', few: 'Poslednja {count} dana · {from} – {to}', other: 'Poslednjih {count} dana · {from} – {to}' },
    colProject: 'Projekat',
    colQuestionnaires: 'Upitnici',
    colCrewDays: 'Dani kolona',
    colMetres: 'Metri',
    colDate: 'Datum',
    colCrew: 'Kolona',
    colType: 'Tip',
    colLength: 'Dužina',
    colPoints: 'Tačke',
    colFix: 'Fix',
    colCity: 'Mesto',
    viewOnMap: 'Prikaži na RTK karti',
    chartExecutedByDay: 'Izvedeni metri po danu',
    chartExecutedByDaySub: 'Ukupno metara po danu',
    chartRtkByDay: 'RTK metri po danu',
    chartRtkByDaySub: 'Snimljeni metri po danu (s izmenjenim dužinama)',
    chartProjectsByMetres: 'Projekti po izvedenim metrima',
    chartRtkByType: 'RTK po vrsti merenja',
    chartRtkByTypeSub: 'slic / trasse su kablovske trase; ostalo su kućni priključci',
    kpiMetres: 'Izvedeno',
    kpiRevenue: 'Prihod (SUB)',
    kpiCrewdays: 'Dani kolona',
    kpiCrews: 'Aktivne kolone',
    kpiProjects: 'Aktivni projekti',
    kpiHours: 'Radni sati',
    kpiSurveyed: 'Snimljeni metri',
    kpiSegments: 'Segmenti',
    kpiPoints: 'Tačke',
    kpiHa: 'Kućni priključci',
    kpiFix: 'Stopa RTK fiksa %',
  },
})
